export enum DeliveryMessageType {
  CONTACT_BEFORE_DELIVERY = "CONTACT_BEFORE_DELIVERY",
  LEAVE_AT_SECURITY = "LEAVE_AT_SECURITY",
  LEAVE_AT_DOOR = "LEAVE_AT_DOOR",
  REQUEST_FAST_DELIVERY = "REQUEST_FAST_DELIVERY",
  LEAVE_IN_LOCKER = "LEAVE_IN_LOCKER",
  CUSTOM = "CUSTOM",
}

export const deliveryMessageTypeDisplayNames = {
  [DeliveryMessageType.CONTACT_BEFORE_DELIVERY]: "배송 전에 미리 연락바랍니다.",
  [DeliveryMessageType.LEAVE_AT_SECURITY]: "부재 시 경비실에 맡겨주세요.",
  [DeliveryMessageType.LEAVE_AT_DOOR]: "부재 시 문 앞에 놓아주세요.",
  [DeliveryMessageType.REQUEST_FAST_DELIVERY]: "빠른 배송 부탁드립니다.",
  [DeliveryMessageType.LEAVE_IN_LOCKER]: "택배함에 보관해 주세요.",
  [DeliveryMessageType.CUSTOM]: "직접 입력",
};
